export default __webpack_public_path__ + "static/media/912.da512158.png";